module.exports = __webpack_public_path__ + "img/frich_En_populaer_sjanger2.49514121.jpg";